module.exports = __webpack_public_path__ + "img/3-t.e7de746c.svg";